import React from "react";

interface AnimatedCircleProps {
  size: number;
  borderWidth: number;
  strokeColor?: string;
}

export const AnimatedCircle: React.FC<AnimatedCircleProps> = ({
  size,
  borderWidth,
  strokeColor = "#40336E",
}) => {
  const center = size / 2;
  const circleRadius = center - borderWidth / 2;
  const circumference = 2 * Math.PI * circleRadius;

  return (
    <svg width={size} height={size} className="transform -rotate-90">
      <circle
        cx={center}
        cy={center}
        r={circleRadius}
        stroke="transparent"
        strokeWidth={borderWidth}
        fill="transparent"
      />
      <circle
        cx={center}
        cy={center}
        r={circleRadius}
        stroke={strokeColor}
        strokeWidth={borderWidth}
        fill="transparent"
        strokeDasharray={circumference}
        strokeDashoffset={circumference}
        strokeLinecap="round"
        className="animate-progress"
        style={{'--circumference': circumference} as React.CSSProperties}
      />
    </svg>
  );
};
